import {SR_LOGOUT, SR_VARIFY_TOKEN} from '@constants/server-route.constant'
import {axiosIns} from 'config/api.config'
import {ENV} from 'config/ENV.config'

export const AuthService = {
  // NB: sso /auth/verify-token binds @RequestParam("appName"); sending appKey left it null,
  // so only app_name='ALL' features came back. Send appName so this app's (ERPBOI_HRM)
  // granted features are returned for permission-gating.
  verifyToken: async (appKey): Promise<any> =>
    await axiosIns.get(SR_VARIFY_TOKEN + '?appName=' + appKey, {baseURL: ENV.ssoGetway}),

  // Single logout: invalidate the SSO-shared token in Redis (sso-service). Once gone,
  // every app holding this token fails its next verify-token and is bounced to login.
  logout: async (): Promise<any> => await axiosIns.post(SR_LOGOUT, {}, {baseURL: ENV.ssoGetway}),
}
